import Instance from '../../../Axios';

// New Actions for the app

const GetLimpezasApartamento = (id) => async (dispatch) => {
  console.log('id', id);
  await Instance()
    .get(`/backend/apartamentos/${id}/checklist`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_LIMPEZAS_APARTAMENTO', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetLimpezasApartamento;
